export const AUTH_TOKEN_COOKIES_KEY = "pageid";

export const passwordRegex =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{12,}$/;
